import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.freeze.js";
// Patched version from
// https://github.com/stevenho0811/nuxt-breakpoints/blob/master/lib/plugin.js
// to behave like the previous one.
//
// Please try to avoid using $breakpoint on the client side, because it causes rerender and blocks flashes
// as we show mobile version at first
import Vue from 'vue';
import throttle from 'lodash/throttle';
// @ts-ignore
var extend = function extend(app, mixin) {
  if (!app.mixins) {
    app.mixins = [];
  }
  app.mixins.push(mixin);
};
var defaultOptions = {
  sm: 768,
  md: 992,
  lg: 1280,
  xl: 1600,
  options: {
    polyfill: true,
    throttle: 200
  }
};
var defaultBreakpoints = {
  // Default breakpoint is xs, because google crawler is mobile first (and we have 48% of users on mobile)
  current: 'xs',
  xs: true,
  sm: false,
  lSm: false,
  sSm: true,
  md: false,
  lMd: false,
  sMd: true,
  lg: false,
  lLg: false,
  sLg: true,
  xl: false,
  width: 0,
  height: 0,
  // For backward compatibility with prev version
  thresholds: Object.freeze(defaultOptions),
  smAndUp: false,
  mdAndUp: false
};
var transformBreakpoints = function transformBreakpoints(breakpoints, _ref, options) {
  var width = _ref.width,
    height = _ref.height;
  var sm = options.sm,
    md = options.md,
    lg = options.lg,
    xl = options.xl;
  var breakpointRoles = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var currentActive = 'xs';
  switch (true) {
    case width >= xl:
      currentActive = 'xl';
      break;
    case width >= lg:
      currentActive = 'lg';
      break;
    case width >= md:
      currentActive = 'md';
      break;
    case width >= sm:
      currentActive = 'sm';
      break;
    default:
      currentActive = 'xs';
      break;
  }
  var decideLargeOrSmallThan = function decideLargeOrSmallThan(point) {
    var large = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return large ? breakpointRoles[point] <= breakpointRoles[currentActive] : breakpointRoles[point] >= breakpointRoles[currentActive];
  };
  var transformData = {
    sm: currentActive === 'sm',
    lSm: decideLargeOrSmallThan('sm', true),
    sSm: decideLargeOrSmallThan('sm'),
    smAndUp: decideLargeOrSmallThan('sm', true),
    md: currentActive === 'md',
    lMd: decideLargeOrSmallThan('md', true),
    sMd: decideLargeOrSmallThan('md'),
    mdAndUp: decideLargeOrSmallThan('md', true),
    lg: currentActive === 'lg',
    lLg: decideLargeOrSmallThan('lg', true),
    sLg: decideLargeOrSmallThan('lg')
  };
  Object.assign(breakpoints, transformData, {
    current: currentActive,
    xs: currentActive === 'xs',
    xl: currentActive === 'xl',
    width: ~~width,
    height: ~~height
  });
};
export default (function (ctx, inject) {
  var options = defaultOptions;
  var breakpoints = Vue.observable(defaultBreakpoints);
  if (process.server) {
    ctx.$breakpoint = breakpoints;
    inject('breakpoint', breakpoints);
    return;
  }

  // const needPolyfill =
  //   !Object.prototype.hasOwnProperty.call(window, 'ResizeObserver') &&
  //   options.options.polyfill

  // if (needPolyfill) {
  //   const ResizeObserver = await import('resize-observer-polyfill')

  //   Object.defineProperty(window, 'ResizeObserver', {
  //     value: ResizeObserver.default,
  //     writable: false
  //   })
  // }

  var bodyElem = document.querySelector('body');
  var resizeObserver = new ResizeObserver(throttle(function (entries) {
    // Prevent error "ResizeObserver loop limit exceeded"
    // https://stackoverflow.com/a/67748232/1044982
    window.requestAnimationFrame(function () {
      var _entries = _slicedToArray(entries, 1),
        contentRect = _entries[0].contentRect;
      transformBreakpoints(breakpoints, contentRect, options);
    });
  }, +options.options.throttle, {
    trailing: true,
    leading: false
  }));

  /**
   * Keep in mind there is no way to get screen width/height during SSR.
   * The first render will be with default breakpoint (mobile, xs).
   *
   * We can't change the breakpoint before beforeMount, otherwise the app will have a rehydration bug
   * in places where we use $breakpoint.
   * Explanation (for react ssr): https://github.com/envato/react-breakpoints/blob/main/docs/server-side-rendering.md
   */
  extend(ctx.app, {
    beforeMount: function beforeMount() {
      resizeObserver.observe(bodyElem);
    },
    beforeDestroy: function beforeDestroy() {
      resizeObserver.unobserve(bodyElem);
    }
  });
  ctx.$breakpoint = breakpoints;
  inject('breakpoint', breakpoints);
});